import React from "react"
import classes from "./knowledgeReport.module.css"

import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"

import PathImg from "../../../../assets/img/assessmentImages/path.svg"
import { updateKnowledgeScore } from "../../../../store/actions/knowledge.action"

export const MyProfileWithPath = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const { hierarchy } = useSelector(state => state.knowledgeReducer)

    return (
        <>
            <div className={classes.profileName}>
                <h2
                    className={"FontPoppins"}
                    onClick={() => history.push("/dashboard/my-profile")}
                >
                    <div onClick={() => history.push("/dashboard/my-profile")}>
                        My Profile
                    </div>
                </h2>

                <div className={classes.breadCrumb}>
                    {hierarchy.map(item => <>
                        <img src={PathImg} key={item.id} />
                        <span key={item.id} onClick={() => dispatch(updateKnowledgeScore(item.id))}>{item.name}</span>
                    </>)}
                </div>
            </div>
        </>
    )

}